export const accountAuthPaths = ['/account'];

export const isAccountAuthPath = (path: string) => accountAuthPaths.includes(path);
